<template>
  <div class="personal-set">
    <!-- 引入公共头部 :showBack="true" :showEdit="true"-->
    <dg-header :showBack="true" title="个人资料" :showEdit="true" :isEdit="edit" @handlerEdit="handlerEdit"></dg-header>
    <div class="personal-set-con">
      <div class="personal-title">基本信息</div>
      <div class="personal-info">
        <!-- 头像 -->
        <div class="personal-list personal-avatar">
          <div class="personal-item">
            <span class="item-span ">头像</span>
            <p class="item-p">
              <span class="item-img dg-small-no-photo" v-if="userInfo.portrait">
                <img :src="userInfo.portrait" alt >
              </span>
            </p>
          </div>
        </div>
        <!-- 姓名，邮箱，性别 -->
        <div class="personal-list">
          <div class="personal-item min-height88 border-bottom1">
            <span class="item-span">剩余额度</span>
            <p class="item-p">
              <span class="personal-right-text">{{userInfo.credits - userInfo.costCredits | setNumber}}</span>
            </p>
          </div>
          <div class="personal-item min-height88 border-bottom1">
            <span class="item-span">姓名</span>
            <p class="item-p" @click="editName">
              <span class="personal-right-text">{{userInfo.nickName || '未知'}}</span>
            </p>
          </div>
          <div class="personal-item min-height88 border-bottom1">
            <span class="item-span">性别</span>
            <p class="item-p" @click="editGender">
              <span class="personal-right-text">{{params.sex || '未填写'}}</span>
              <van-icon name="arrow" v-if="isEdit"/>
            </p>
          </div>
          <div class="personal-item min-height88 border-bottom1">
            <span class="item-span">账号昵称</span>
            <p class="item-p">
              <span class="personal-right-text">{{userInfo.name}}</span>
            </p>
          </div>
          <div class="personal-item min-height88 border-bottom1">
            <span class="item-span">电话号码</span>
            <p class="item-p">
              <span class="personal-right-text" v-if="!isEdit">{{params.phone || '未填写'}}</span>
              <input type="text" v-model="params.phone" v-if="isEdit">
            </p>
          </div>
          <div class="personal-item min-height88">
            <span class="item-span">邮箱号码</span>
            <p class="item-p">
              <span class="personal-right-text" v-if="!isEdit">{{params.email || '未填写'}}</span>
              <input type="text" v-model="params.email" v-if="isEdit">
            </p>
          </div>
        </div>
        <div class="submit-btn" @click="submit()" v-if="isEdit">立即修改</div>
      </div>
    </div>
    <!-- 修改姓名弹框 -->
<!--    <van-dialog v-model="modifyNameShow" title="修改姓名" show-cancel-button>-->
<!--      <van-field v-model="value" placeholder/>-->
<!--    </van-dialog>-->
    <!-- 修改性别picker 选择器 -->
    <van-dialog v-model="modifySexShow" :showConfirmButton="false">
      <!-- <button class="modify-btn on">11</button> -->
      <button
        v-for="(colum,index) in columns"
        :key="index"
        class="modify-btn"
        :class="params.sex === colum || index === active ? 'on' : ''"
        @click="switchSexOption(colum,index)"
      >{{colum}}</button>
    </van-dialog>
  </div>
</template>
<script>
import DgHeader from "@/components/header";
import api from '@/server'
export default {
  data() {
    return {
      modifyNameShow: false, // 修改姓名弹框
      modifySexShow: false, // 修改性别弹框
      columns: ["女", "男"],
      active: '',
      params: {
        id: '',
        phone: '',
        sex: '',
        email: ''
      },
      userInfo: '',
      // 是否为编辑状态
      isEdit: false,
      // 文字编辑、取消状态
      edit: false
    };
  },
  activated() {
    if(localStorage.getItem('token')) {
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    }
    this.getUserInfos();

  },
  deactivated() {
    this.isEdit = false
  },
  methods: {
    // 修改姓名弹框显示
    editName() {
      this.modifyNameShow = !this.modifyNameShow;
    },
    // 修改性别弹框显示
    editGender() {
      if(this.isEdit) {
        this.modifySexShow = !this.modifySexShow;
      }
    },
    // 点击切换性别
    switchSexOption(item, index) {
      this.active = index;
      this.params.sex = item;
      this.modifySexShow = false;
    },
    // 根据用户id查询用户信息
    getUserInfos() {
      api.getUserInfo({
        id: this.$route.query.id
      }).then(res=> {
        if (res.code === 200 && res.data) {
          this.userInfo = res.data;
          localStorage.setItem('userInfo', JSON.stringify(res.data))
          this.params = {
            sex: res.data.sex,
            phone: res.data.phone,
            email: res.data.email,
            id: res.data._id
          }
        } else {
          this.userInfo = {};
        }
      }).catch(err=> {
        console.log(err)
      })
    },
    //编辑完善资料
    handlerEdit(flag) {
      this.isEdit = flag;
      this.edit = flag;
    },
    // 提交资料
    submit() {
      this.userInfo = Object.assign(this.userInfo, this.params)
      api.editUserInfo(this.params).then(res=> {
       if (res.code === 200) {
         this.$toast.success('操作成功');
         this.isEdit = false;
         this.edit = false;
       } else {
         this.$toast.fail(res.msg);
         this.params.sex = this.userInfo.sex;
         this.params.phone = this.userInfo.phone;
         this.params.email = this.userInfo.email;
       }
      }).catch(err=> {
        console.log(err)
      })
    }

  },
  components: {
    DgHeader
  }
};
</script>
<style lang="scss" >
.personal-set {
  .personal-title {
    width: 100%;
    height: 80px;
    line-height: 80px;
    padding: 0 40px;
    text-align: left;
    font-size: 28px;
    color: $fc06;
    background: $bg02;
  }
  .personal-info {
    width: 100%;
    padding: 30px;
    box-sizing: border-box;
    .personal-list {
      width: 100%;
      padding: 15px 30px;
      box-sizing: border-box;
      background: $bg02;
      border-radius: $br30;
      overflow: hidden;
      box-shadow: $box-shadow3;
      .personal-item {
        width: 100%;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        .item-span {
          font-size: 28px;
          color: $fc09;
        }
        .input-height{
          height: 68px;
        }
        .item-p {
          flex: 1;
          text-align: right;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          .van-icon-arrow{
            text-align: right;
            margin-left: 45px;
          }
          input{
            width: 80%;
            height: 68px;
            color: $fc06;
            text-align: center;
            font-size: 28px;
            background: rgba(0,0,0,0.1);
          }
          .item-img {
            width: 90px;
            height: 90px;
            border-radius: 50%;
            overflow: hidden;
            display: inline-block;
            > img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          .van-icon {
            font-size: 42px;
            color: $fc09;
            display: inline-block;
          }
          .margin-right45 {
            margin-right: 45px;
          }
          &:active {
            .van-icon {
              color: $fc06;
            }
          }
        }
        .personal-right-text {
          font-size: 28px;
          color: $fc06;
        }
      }
      .min-height88 {
        min-height: 88px;
      }
      .border-bottom1 {
        border-bottom: 1px solid $bc04;
      }
    }
    .submit-btn{
      width: 100%;
      height: 88px;
      text-align: center;
      font-size: 30px;
      background: $btn01;
      border-radius: 44px;
      line-height: 88px;
      margin-top: 45px;
      color: white;
      &:active{
        background: $btnHover01;
      }
    }
    .personal-avatar {
      margin-bottom: 8px;
    }
  }
  .van-dialog {
    width: 600px;
    border-radius: $br20;
    padding: 30px 30px 30px;
    box-sizing: border-box;
    .van-dialog__header{
      padding-top: 0;
      margin-bottom: 30px;
    }
    // 修改姓名input框样式
    .van-field__control {
      width: 100%;
      height: 68px;
      line-height: 68px;
      background: $bg01;
      border-radius: $br50;
      padding: 0 30px;
      font-size: 30px;
      color: $fc03;
    }
    // 选择性别按钮样式
    .modify-btn {
      width: 100%;
      height: 68px;
      line-height: 68px;
      text-align: center;
      @include resetButton();
      border: 2px solid $bc02;
      background: $bg02;
      border-radius: $br40;
      margin-bottom: 20px;
      font-size: 30px;
      color: $fc09;
      &:first-child{
        margin-top: 30px;
      }
    }
    .on {
      background: $bg03;
      border: 0;
      color: $fc02;
    }
    .van-dialog__footer--buttons {
      justify-content: space-around;
      margin-top: 60px;
      .van-button {
        width: 240px;
        height: 80px;
        line-height: 80px;
        border-radius: $br50;
        color: $fc02;
        font-size: 30px;
        flex: inherit;
      }
      .van-dialog__cancel {
        background: $bg04;
      }
      .van-dialog__confirm {
        background: $bg05;
      }
    }
    .van-hairline--top::after{
      border-top-width: 0 !important;
    }
    .van-hairline--left::after {
      border-left-width: 0 !important;
    }
  }
}
</style>
